import React from 'react';
import {
  Paper,
  Box,
  Chip,
  Typography,
  Button
} from '@mui/material';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import InventoryIcon from '@mui/icons-material/Inventory';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useCatalogContext } from './CatalogContext';

const CatalogSelectionToolbar = () => {
  const {
    selectedProducts,
    handleClearSelections,
    handleBatchAction,
    setBatchActionAnchorEl
  } = useCatalogContext();

  const isMobile = window.innerWidth < 600;

  if (selectedProducts.length === 0) return null;

  return (
    <Paper
      sx={{
        position: 'sticky',
        bottom: 16,
        mb: 2,
        p: 1.5,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        bgcolor: '#e3f2fd',
        border: '1px solid #90caf9',
        borderRadius: 2,
        boxShadow: 2,
        zIndex: 10
      }}
      elevation={3}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <Chip
          label={`${selectedProducts.length} ${selectedProducts.length === 1 ? 'produto' : 'produtos'}`}
          color="primary"
          sx={{ fontWeight: 'medium' }}
        />
        <Typography variant="body2">
          selecionado(s)
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Button
          size="small"
          onClick={handleClearSelections}
          sx={{ color: 'text.secondary' }}
        >
          Limpar
        </Button>

        {!isMobile && (
          <>
            <Button
              size="small"
              variant="outlined"
              onClick={() => handleBatchAction('update_price')}
              startIcon={<LocalOfferIcon />}
            >
              Atualizar CMVs
            </Button>
            <Button
              size="small"
              variant="outlined"
              onClick={() => handleBatchAction('update_stock')}
              startIcon={<InventoryIcon />}
              disabled
            >
              Atualizar Estoque
            </Button>
          </>
        )}
        <Button
          size="small"
          variant="contained"
          color="primary"
          endIcon={<ArrowDropDownIcon />}
          disabled
        >
          Mais ações
        </Button>
        <Box id="batch-menu-anchor" sx={{ display: 'none' }} />
      </Box>
    </Paper>
  );
};

export default CatalogSelectionToolbar;
